import type { SxProps, Theme } from '@mui/material/styles'
import { banhangKiotLike } from '@/components/layout/banhangKiotTokens'

export {
  getKiotListToolbarPrimaryOutlineButtonSx,
  getKiotListToolbarErrorOutlineButtonSx,
  kiotListToolbarContainedButtonSx,
  kiotListToolbarNeutralOutlineButtonSx,
  kiotToolbarButtonStartIconSx,
} from '@/components/layout/banhangKiotTokens'

/** Cụm nút bên phải header list (Thêm / Nhập / Xuất / cột). */
export const listToolbarActionsRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: { xs: 'flex-start', sm: 'flex-end' },
  gap: 1,
  flexWrap: 'wrap',
  flexShrink: 0,
  width: { xs: '100%', sm: 'auto' },
}

export const listToolbarOutlineStartIconSx = { fontSize: 20 } as const

export const listToolbarOutlineEndIconSx = { fontSize: 22 } as const

export const listToolbarColumnMenuCheckboxSx: SxProps<Theme> = {
  py: 0,
  mx: 0,
  my: 0,
  alignItems: 'flex-start',
  width: '100%',
  minWidth: 0,
  '& .MuiCheckbox-root': {
    p: 0.5,
    pt: 0.25,
    color: '#bdbdbd',
    '&.Mui-checked': { color: 'primary.main' },
  },
  '& .MuiFormControlLabel-label': {
    fontSize: `${banhangKiotLike.kiotFontSizePx}px`,
    lineHeight: 1.45,
    fontFamily: banhangKiotLike.kiotFontStack,
    color: banhangKiotLike.kiotTextPrimary,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
}
